module.exports = __webpack_public_path__ + "static/2_1_search-2_LT-be6f86bbd8c907e7006bd102b7d0af65.svg";